/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Table, Input, Empty, Typography, Select } from 'antd'
// import './index.scss'
import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'
import {
	BUILT_YEAR,
	COOKING_FUEL,
	FLOORS_NUMBER,
	FLOOR_AREA,
	FLOOR_CONSTRUCTION_MATERIALS,
	FLOOR_FINISHING_MATERIALS,
	GARBAGE_DISPOSAL,
	HOUSE_ACQUISITION,
	LAND_LOCATION,
	LAND_OWNERSHIP,
	LIGHTING_FUEL,
	MONTHLY_RENTAL,
	OUTERWALLS_MATERIALS,
	PRESENCE_OPERATOR,
	REPAIR_STATE,
	RESIDENTIAL_TYPE,
	ROOF_MATERIALS,
	TENURE_STATUS,
	TOILET_FACILITY,
	WATER_SUPPLY_COOKING,
	WATER_SUPPLY_DRINKING
} from '../../../constants/householdlookup'
import PurokLookup from '../../../components/Custom/PurokSelect'

// import ConstituentAvatar from '../../../components/Custom/ConstituentAvatar'
import SubscribeProgress from '../subscribeProgress'
// import ViewDetails from '../../Certificates/modalDetails'

const { Title } = Typography

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			page: 1,
			pageSize: 10,
			searchText: '',
			sortOrder: null,
			sortName: null,
			isExporting: false,
			exportProgress: null,
			customFilter: {}
		}
        
		this.handleOnChange = this.handleOnChange.bind(this)
	}
    
	handleOnChange(pagination, filters, sorter) {
		this.setState({
			page: pagination.current,
			pageSize: pagination.pageSize,
			sortOrder: (sorter.order === 'ascend') ? 'asc' : 'desc',
			sortName: sorter.field,
			// reservation_status: filters.status,
		})
	}

	render() {
		const { AuthStore } = this.props
		const { barangay_uid, user_uid } = AuthStore
		const { page, pageSize, sortOrder, sortName, searchText,
			isExporting, exportProgress, customFilter
		} = this.state
		let filters = { 
			page, pageSize, searchText, sortOrder, sortName, customFilter
		}
		return (
			<Row type='flex' justify='center'>
				<Col md={24} sm={24}>
					<Row style={{
						padding: 20,
						marginBottom: 20,
						borderRadius: 10
					}}
						className='report-box'
					>
						<Title level={4}>Filters</Title>
						<Row gutter={16}>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%' }}
									placeholder='Select Built Year'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { built_year: value }) })
									}}
								>
									{
										BUILT_YEAR.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%' }}
									placeholder='Select cooking fuel'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { cooking_fuel: value }) })
									}}
								>
									{
										COOKING_FUEL.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%' }}
									placeholder='Select floor numbers'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { floor_numbers: value }) })
									}}
								>
									{
										FLOORS_NUMBER.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%' }}
									placeholder='Select floor area'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { floor_area: value }) })
									}}
								>
									{
										FLOOR_AREA.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%' }}
									placeholder='Select floor construction materials'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { floor_construction_materials: value }) })
									}}
								>
									{
										FLOOR_CONSTRUCTION_MATERIALS.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%' }}
									placeholder='Select floor finishing materials'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { floor_finishing_materials: value }) })
									}}
								>
									{
										FLOOR_FINISHING_MATERIALS.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%' }}
									placeholder='Select garbage disposal'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { garbage_disposal: value }) })
									}}
								>
									{
										GARBAGE_DISPOSAL.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%' }}
									placeholder='Select house acquisition'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { house_acquisition: value }) })
									}}
								>
									{
										HOUSE_ACQUISITION.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%' }}
									placeholder='Select land location'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { land_location: value }) })
									}}
								>
									{
										LAND_LOCATION.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%' }}
									placeholder='Select land ownership'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { land_ownership: value }) })
									}}
								>
									{
										LAND_OWNERSHIP.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%' }}
									placeholder='Select lighting fuel'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { lighting_fuel: value }) })
									}}
								>
									{
										LIGHTING_FUEL.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%' }}
									placeholder='Select monthly rental'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { monthly_rental: value }) })
									}}
								>
									{
										MONTHLY_RENTAL.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%' }}
									placeholder='Select outerwall materials'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { outerwall_materials: value }) })
									}}
								>
									{
										OUTERWALLS_MATERIALS.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%' }}
									placeholder='Select presence of operator'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { presence_operator: value }) })
									}}
								>
									{
										PRESENCE_OPERATOR.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%' }}
									placeholder='Select repair state'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { repair_state: value }) })
									}}
								>
									{
										REPAIR_STATE.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%' }}
									placeholder='Select residential type'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { residential_type: value }) })
									}}
								>
									{
										RESIDENTIAL_TYPE.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%' }}
									placeholder='Select roof materials'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { roof_materials: value }) })
									}}
								>
									{
										ROOF_MATERIALS.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%' }}
									placeholder='Select tenure status'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { tenure_status: value }) })
									}}
								>
									{
										TENURE_STATUS.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%' }}
									placeholder='Select toilet facility'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { toilet_facility: value }) })
									}}
								>
									{
										TOILET_FACILITY.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%' }}
									placeholder='Select water supply for drinking'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { water_supply_drinking: value }) })
									}}
								>
									{
										WATER_SUPPLY_DRINKING.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%' }}
									placeholder='Select water supply for cooking'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { water_supply_cooking: value }) })
									}}
								>
									{
										WATER_SUPPLY_COOKING.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
						</Row>
						<Row gutter={16} style={{ marginTop: 15 }}>
							<Col md={6} sm={24}>
								<PurokLookup 
									allowClear
									style={{ width: '100%' }}
									barangay_uid={barangay_uid}
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { purok: value }) })
									}}
								/>
							</Col>
							<Col md={18} sm={24}>
								<Input 
									placeholder='Enter address'
									style={{ width: '100%' }}
									barangay_uid={barangay_uid}
									onChange={(e) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { address: e.target.value }) })
									}}
								/>
							</Col>
						</Row>
					</Row>
					<Row>
						<Col md={6} sm={24}>
							<button 
								type="button" 
								className="btn btn-outline-success btn-rounded waves-effect waves-light"
								onClick={() => {
									const { exportHouseholds } = this.props
									const params = {
										// date_start: moment(dateRange[0]).format('YYYY-MM-DD HH:mm:ss'),
										// date_end: moment(dateRange[1]).format('YYYY-MM-DD HH:mm:ss'),
										searchText,
										customFilter
									}
									exportHouseholds(params)
								}}
							>
								<i className='mdi mdi-file-excel'/> Export in Excel
							</button>
						</Col>
						<Col md={18} sm={24}>
							<Row style={{ textAlign: 'right' }}>
								<Input 
									style={{ width: 300 }}
									placeholder='Search Here..' 
									onChange={(e)=>{
										this.setState({ searchText: e.target.value })
									}}/>
							</Row>
						</Col>
					</Row>
					<br />
					<Row>
						<Query 
							query={BARANGAY_HOUSEHOLD} 
							variables={{ 
								searchFilter: filters, 
								barangay_uid
							}}
							fetchPolicy='network-only'
						>
							{({ loading, error, data, subscribeToMore }) => {
								if (error) return <Empty/>

								let households = _.has(data,'allBarangayHousehold') ? data.allBarangayHousehold.data : []
								households = households.map((household, key) => Object.assign({}, household, { key }))
								let _pagination = _.has(data, 'allBarangayHousehold') ? data.allBarangayHousehold.pagination : {}
								_pagination = Object.assign({}, _pagination, {
									pageSizeOptions: ['10', '25', '50'],
									showSizeChanger: true,
									total: _.has(_pagination, 'rowCount') ? _pagination.rowCount : 0,
									showTotal: (total) => `Total ${total} items`
								})

								const columns = [
									{
									 	title: 'Household No.',
									 	dataIndex: 'household_no',
									 	key: 'household_no',
									 	width: 120
									}, {
										title: 'Member Count',
										dataIndex: 'member_count',
										key: 'member_count',
										width: 130
									}, {
										title: 'Head of Household',
										key: 'head_first_name',
										width: 200,
										render: (record) => (
											<span style={{ color: 'blue' }}>{record.head_first_name} {record.head_last_name}</span>
										)
									}, {
										title: 'Address',
										key: 'address',
										render: (i) => {
											const address = `${i.house_no || ''} ${i.block || ''} ${i.lot || ''} ${i.street || ''} ${i.address || ''} ${i.purok_name || ''}`
											return (
												<span>{address}</span>
											)
										}
									}]
								return (
									<Row>
										<Row style={{ marginBottom: 10 }}>
											<SubscribeProgress
												exportProgress={exportProgress}
												isExporting={isExporting}
												subscribeToExportProgress={() => {
													subscribeToMore({
														document: EXPORT_PROGRESS,
														variables: { user_uid, process_name: 'households' },
														updateQuery: (prev, { subscriptionData }) => {
															// console.log('[NEW_MESSAGE] previous value', prev)
															// console.log('[NEW_MESSAGE] subscriptionData value', subscriptionData)
															if (_.isEqual(subscriptionData.data.exportProgress.status, 'exporting')) {
																this.setState({ isExporting: true, exportProgress: subscriptionData.data.exportProgress })
															} else {
																this.setState({ isExporting: false, exportProgress: null })
															}
														}
													})
												}}
											/>
										</Row>
										<Row>
											<Table 
												loading={loading}
												columns={columns} 
												dataSource={households} 
												bordered
												onChange={this.handleOnChange}
												pagination={_pagination}
												scroll={{ x: 1020 }}
											/>
										</Row>
									</Row>
								)
							}}
						</Query>
					</Row>
				</Col>
			</Row>
		)
	}
}

const BARANGAY_HOUSEHOLD = gql`
    query allBarangayHousehold($barangay_uid: String, $searchFilter: SearchParams) {
		allBarangayHousehold(barangay_uid: $barangay_uid, searchFilter: $searchFilter)
    }
`

const EXPORT_HOUSEHOLD = gql`
    mutation exportHouseholds($input: JSON) {
		exportHouseholds(input: $input)
    }
`

const EXPORT_PROGRESS = gql`
	subscription exportProgress($user_uid: String, $process_name: String) {
		exportProgress(user_uid: $user_uid, process_name: $process_name)
	}
`

const composed = compose(
	inject('AuthStore'),
	graphql(EXPORT_HOUSEHOLD, {
		props({ mutate }) {
			return {
				exportHouseholds(params) {
					return mutate({
						variables: { input: params },
					  	// refetchQueries: ['visitorLogs']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
